import { ReactNode, useMemo } from 'react';
import { NavigationContext } from './useNavigation';

interface NavigationProviderProps {
  children: ReactNode;
  onItemClick?: () => void;
  currentDepth?: number;
}

export const NavigationProvider = ({
  children,
  onItemClick,
  currentDepth = 0,
}: Readonly<NavigationProviderProps>) => {
  const value = useMemo(
    () => ({ onItemClick, currentDepth }),
    [onItemClick, currentDepth],
  );
  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};
